export const EMPTY_GENERAL_FIELD = 900;
export const EMPTY_TEXT_FIELD = 901;
export const EMPTY_SELECT_FIELD = 902;
export const INVALID_FORMAT_USER_EMAIL_LOCAL = 903;
export const INVALID_FORMAT_USER_PHONE_LOCAL = 904;

export const localErrorMessagesMap = {
  [EMPTY_TEXT_FIELD]: {
    id: 'Patient.Case.Update.MissingMandatoryFieldError.TextField',
    defaultMessage: '** Mandatory Field',
  },
  [EMPTY_SELECT_FIELD]: {
    id: 'Patient.Appointment.Create.MissingMandatoryFieldError.Selection',
    defaultMessage: '** :attribute selection is required',
  },
  [INVALID_FORMAT_USER_EMAIL_LOCAL]: {
    id: 'Patient.Appointment.Create.WrongEmailFormatError',
    defaultMessage: '** Wrong Email format',
  },
  [INVALID_FORMAT_USER_PHONE_LOCAL]: {
    id: 'MyAccount.Details.Edit.InvalidPhoneNoFormatError',
    defaultMessage: '** Invalid phone number format',
  },
  [EMPTY_GENERAL_FIELD]: {
    id: 'General.RequiredField',
    defaultMessage: '** Required field',
  },
};
